import { render, staticRenderFns } from "./FormVersionManager.vue?vue&type=template&id=4766d2dc&"
import script from "./FormVersionManager.vue?vue&type=script&lang=js&"
export * from "./FormVersionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports